import { HelpTextMarkdown } from '@diagentech/exprworks-ui-components';
import React from 'react';

import { withAboutAuthorText, WithAboutAuthorTextProps } from '@/components/info/withAboutAuthorText';

interface AboutAuthorContentProps extends WithAboutAuthorTextProps {}

export const AboutAuthorContentComponent: React.FC<AboutAuthorContentProps> = ({ text }) => {
  return <HelpTextMarkdown id="about-author" text={text} />;
};

export const AboutAuthorContent = withAboutAuthorText(AboutAuthorContentComponent);
